import { render, staticRenderFns } from "./SectionPills.vue?vue&type=template&id=4309e84c&scoped=true&"
import script from "./SectionPills.vue?vue&type=script&lang=ts&"
export * from "./SectionPills.vue?vue&type=script&lang=ts&"
import style0 from "./SectionPills.vue?vue&type=style&index=0&id=4309e84c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4309e84c",
  null
  
)

export default component.exports